// extracted by mini-css-extract-plugin
export var list = "how-academy-works-list-module--list--JE00U";